export function snakeToCamel(s: string, capitalize: boolean = true): string {
  const camelCase = s.replace(/(_\w)/g, (m) => m[1].toUpperCase());
  if (!capitalize) return camelCase;
  // Ensure the first letter is uppercase
  return camelCase.charAt(0).toUpperCase() + camelCase.slice(1);
}
